function complete(id, postComplete = null) {
  if(! window.gameMap) {
    console.error(`No game map found.`)
    return
  }
  const map = window.gameMap
  if(! map[id] ) {
    console.warn(`No onComplete call found for ${id}.`)
    return
  }
  if( map[id].completed ) {
    return
  }
  map[id].completed = true
  const fn = map[id].onComplete
  if(typeof fn === "function") {
    fn()
  }
  if(postComplete) {
    postComplete()
  }
}

export {complete}
